
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const OrangeDiamondIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M12.963 2.286a.75.75 0 0 0-1.026 0 2.25 2.25 0 0 0-1.74 2.088L12 18.75l1.74-14.376a2.25 2.25 0 0 0-1.777-2.088Z" // Simplified Diamond
      clipRule="evenodd" 
    />
     <path 
      fillRule="evenodd" 
      d="M12 21.75L3.273 9.163A9.75 9.75 0 0 1 12 2.25c2.994 0 5.738 1.335 7.612 3.488L12 21.75Z" // More standard diamond shape
      clipRule="evenodd" 
    />
  </svg>
);

export default OrangeDiamondIcon;